// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const getContentSearchParameter = (state: ApplicationState) => {
    return state.starter.pages.productList.getContentSearchApiParameter;
};

export const getContentSearchCurrentTab = (state: ApplicationState) => {
    const location = getLocation(state);
    const parsedQueryString: { currentTab: "" } = parseQueryString(location.search);
    // Need this to avoid returning an undefined currentTab and seeing the page blink when reloading the page in the "content" tab.
    return state.starter.pages.productList.getContentSearchApiParameter.currentTab || parsedQueryString.currentTab;
};
